<template>
  <div id="app">
    <div class="flipbook-wrapper">
      <flipbook
              ref="flipbook"
              class="flipbook" :pages="pages">
      </flipbook>
    </div>
    <div class="nav">
      <div class="actions">
        <button @click="previousPage">
          <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M3 12l18-12v24z"/></svg>
        </button>
        <div class="page-num">
          {{ flipbook ? flipbook.currentPage + 1 : 0 }} / {{ flipbook ? flipbook.numPages + 1 : 0 }}
        </div>
        <button @click="nextPage">
          <svg fill="currentColor"  xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M6 0l12 12-12 12z"/></svg>
        </button>
      </div>
    </div>
  </div>
</template>
<script>

  import Flipbook from 'flipbook-vue/vue2'

  export default {
  name: 'App',
    components: {
      Flipbook,
    },
    data(){
      return {
        flipbook: null
      }
    },
    mounted(){
     this.flipbook = this.$refs.flipbook;
    },
    methods: {
      previousPage(){
        this.$refs.flipbook.flipLeft();
      },
      nextPage(){
        this.$refs.flipbook.flipRight();
      }
    },
    computed: {
      pages(){
        let pages = [null];
        for(let i = 1; i <= 12; i++){
          pages.push('./pages/page' + i + '.jpg')
        }
        return pages;
      }
    }
}
</script>
<style>
  body {
    margin: 0;
    padding: 0;
  }
  #app {
    height: calc(100vh);
    overflow: hidden;
    display: flex;
    padding: 20px;
    background: #c3c3c3;
  }
  .flipbook {
    overflow: hidden;
    height: 85vh;
    width: 100vw;
  }

  .nav {
    z-index: 40;
    position: fixed;
    bottom: 20px;
    width:100%;
  }

  .actions {
    height: 40px;
    display: flex;
    width: 140px;
    background: #2a2a2a;
    margin: 0 auto;
    border-radius: 5px;
  }

  button {
    cursor: pointer;
    margin: 0 3px;
    background: transparent;
    border: 0;
    color: #ffffff;
  }

  .page-num {
    width: 100px;
    text-align: center;
    color: #fff;
    padding: 10px;
  }


</style>